import { styled } from "@mui/material/styles";
import { gray, brand } from '../getTheme/getTheme';

// Styling for Authenticator components:
export const AmplifyWrapper = styled('div')({
    '& .federated-sign-in-button': {
        backgroundColor: 'transparent !important',
        border: `1px solid ${gray[50]} !important`,
        color: `${gray[50]} !important`,
        position: 'relative',
    },
    '& .federated-sign-in-button .amplify-text': {
        color: `${gray[50]} !important`,
    },
    '& .federated-sign-in-button:hover': {
        backgroundColor: `linear-gradient(45deg, ${brand[800]} 20%, ${brand[900]} 90%)`,
        border: '1px solid transparent !important',
        borderImage: `linear-gradient(45deg, ${brand[400]} 20%, ${brand[700]} 90%) 1 !important`,
    },
    '& .federated-sign-in-button:active': {
        backgroundColor: `${brand[900]} !important`,
        borderColor: `${brand[300]} !important`,
    },
    // Suppress its error messages to the UI so we can display them ourselves
    '& .amplify-alert': {
        display: 'none !important'
    },
    '& .amplify-alert--error': {
        display: 'none !important'
    },
    // The Amplify router uses an attribute selector for `data-amplify-router-content` rather than a class selector.
    // So the correct way to target it in styled-components is:
    '& [data-amplify-router]': {
        backgroundColor: 'transparent !important',
        boxShadow: 'none !important',
    },    
    '& .amplify-divider--label::after': {
        backgroundColor: 'var(--mui-palette-grey-900) !important',
        color: 'white !important',
    },
    // Hide the entire tab navigation bar
    '& [data-amplify-router] [role="tablist"]': {
        display: 'none !important'
    }
});
